import { render, staticRenderFns } from "./HasScopeEffect.vue?vue&type=template&id=2915b096&"
import script from "./HasScopeEffect.vue?vue&type=script&lang=ts&"
export * from "./HasScopeEffect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports